const CONSTANTS = {
  SEE_LOGS: process.env.SEE_LOGS,
};

export { CONSTANTS };
